import useStateHandler from "@/hooks/useStateHandler";
import Text from "@/shared-components/text/components/Text";

import './styles/InspiringNavigation.css';

export default function InspiringNavigation({ userProfileId, currentPage, setCurrentPage, inspiringCount, followingCount }) {
  const { state } = useStateHandler();
  const userId = state?.user_session?.id;
  const activeTab = currentPage;

  const onClick = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <div className="search-inspiring-navigation__container">
        <button
          className={`search-inspiring-navigation__tab ${
            activeTab === "inspiring" ? "active" : ""
          }`}
          onClick={() => onClick("inspiring")}
        >
          <Text className="search-inspiring-navigation__tab-text" large>
            Inspiring ({inspiringCount})
          </Text>
        </button>
        {userProfileId == userId && (
          <button
            className={`search-inspiring-navigation__tab ${
              activeTab === "following" ? "active" : ""
            }`}
            onClick={() => onClick("following")}
          >
            <Text className="search-inspiring-navigation__tab-text" large>
              Following ({followingCount})
            </Text>
          </button>
        )}
      </div>
    </>
  );
}